import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

class ProductSlider extends HTMLElement {
  constructor() {
    super();

    const { slideCount } = this.dataset;
    const showSliderUI = slideCount > 3;

    this.swiper = new Swiper(this.querySelector('.swiper'), {
      spaceBetween: 10,
      modules: [Navigation, Pagination],
      slidesPerView: 'auto',
      centeredSlides: true,
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        bulletClass: 'w-2 h-2 bg-gray-200 rounded-full transition-all duration-500 ease-in-out',
        bulletActiveClass: '!bg-gray-600 !w-4 3',
      },
      breakpoints: {
        1024: {
          centerInsufficientSlides: true,
          slidesPerView: showSliderUI ? 3 : 'auto',
          slidesPerGroup: 3,
          centeredSlides: false,
          navigation: {
            enabled: showSliderUI,
            nextEl: this.querySelector('.swiper-button-next'),
            prevEl: this.querySelector('.swiper-button-prev'),
          },
        },
        768: {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          centeredSlides: false,
          slidesOffsetBefore: 25,
          slidesOffsetAfter: 25,
        },
      },
    });
  }
}

customElements.define('product-slider', ProductSlider);
